import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import { useHistory } from "react-router-dom";

function MenuItemsListTemplateComponent({
  templateModal: {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters,
    tableConfig,
    tableParams,
  },
  templateEvents: {
    getMenuItemData,
    handleCreateClick,
    deleteRecords,
    submitFilter,
    handleTemplateDownload,
    handleDownload,
  },
}) {
  const settingFormCreate = `${breadCrumbs[1].menu_url}/create`;
  const settingFormEdit = `${breadCrumbs[1].menu_url}/edit`;
  const formUpload = `${breadCrumbs[1].menu_url}/upload`;

  const history = useHistory();
  const handleFormUploadClick = () => {
    history.push(formUpload);
  };

  const ActionContent = ({ handleCreateClick }) => {
    return (
      <>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleFormUploadClick}
          style={{ marginRight: 10 }}
        >
          <FeatherIcon icon="upload" size={17} />
        </button>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={handleCreateClick}
        >
          <FeatherIcon icon="plus" size={17} />
        </button>
        &nbsp; &nbsp;
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={handleTemplateDownload}
          style={{ marginRight: 10 }}
        >
          <FeatherIcon icon="download" size={17} />
        </button>
      </>
    );
  };

  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"All Menu Items"}
        breadCrumbs={breadCrumbs}
        actionContent={<ActionContent handleCreateClick={handleCreateClick} />}
      />
      <DataGridComponent
        title={tableTitle}
        keyColumn={keyColumn}
        tableData={tableData}
        tableColumn={tableColumn}
        totalCount={totalCount}
        dataRefresh={getMenuItemData}
        editLink={settingFormEdit}
        deleteRecords={deleteRecords}
        breadCrumbs={breadCrumbs}
        filters={filters}
        submitFilter={submitFilter}
        tableConfig={tableConfig}
        tableParams={tableParams}
        handleDownload={handleDownload}
      />
    </PageWrapperComponent>
  );
}

export default MenuItemsListTemplateComponent;
